<template>
  <div class="drawer" >
    <el-drawer
      size="650px"
      :visible.sync="drawerStatus"
      @close="close"
      :title="'活体退宠'"
      :wrapperClosable="false"
      :append-to-body="true"
    >
      <div class="msgBox">
        <span>退换备注:</span>
        <div>
          <el-input
            type="textarea"
            v-model="remark"
            aria-placeholder="不能少于15字"
          ></el-input>
        </div>
      </div>
      <div class="msgBox">
        <span>
          退款金额:
          <span style="color: red">{{ tabInfo[0].price }}</span>
        </span>
      </div>
    
      <div class="msgBox">
        <span>宠物状态:</span>
        <div class="msgBoxL">
          <el-radio v-model="isDeath" label="false">正常</el-radio>
          <el-radio v-model="isDeath" label="true">亡故</el-radio>
        </div>
      </div>
      <div v-if="isDeath == 'true'">
        <div class="msgBox">
          <span>亡故日期:</span>
          <el-date-picker
            v-model="deathInfo.deathDate"
            type="date"
            placeholder="选择日期"
          ></el-date-picker>
        </div>
        <div class="msgBox">
          <span>亡故照片:</span>
          <div class="drawerComR" style="display: flex">
            <div
              v-for="(item, index) in deathInfo.deathImg"
              :key="index"
              class="imgItem"
              style="display: inline-block"
            >
              <img
                alt
                :src="item"
                v-if="deathInfo.deathImg.length > 0"
                class="avatar"
              />
              <i
                class="el-icon-error closeBtn"
                v-if="deathInfo.deathImg.length > 0"
                @click="handleDeleteBannerImgClick(index)"
              ></i>
            </div>
            <i
              class="el-icon-plus avatar-uploader-icon"
              @click="handleUploadClick"
              v-if="deathInfo.deathImg.length < 4"
            ></i>
            <input
              type="file"
              ref="file"
              style="width: 0; height: 0"
              @change="changeFile"
            />
          </div>
        </div>
        <div class="msgBox">
          <span>亡故说明:</span>
          <div>
            <el-input
              type="textarea"
              v-model="deathInfo.deathRemark"
              aria-placeholder="不能少于15字"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="msgBox">
        <span>转换余额:</span>
        <div class="msgBoxL">         
          <el-radio v-model="isReturnYuE" label="false">否</el-radio>
          <el-radio v-model="isReturnYuE" label="true">是</el-radio>
        </div>
      </div>
      <div class="msgBox" v-show="isReturnYuE == 'false'">
        <div style="margin-left: 50px; vertical-align: middle">
          <div class="msgBoxL">收款人姓名:</div>
          <el-input
            v-model="returnAccountParam.name"
            placeholder="请输入收款人姓名"
          ></el-input>

          <div class="msgBoxL">开户行:</div>
          <el-input
            v-model="returnAccountParam.bank_name"
            placeholder="请输入开户行信息"
          ></el-input>

          <div class="msgBoxL">银行卡号:</div>
          <el-input
            v-model="returnAccountParam.card_no"
            placeholder="请输入卡号"
          ></el-input>
        </div>
      </div>
      <div class="msgBox" v-show="isReturnYuE == 'true'">
        <span>销售人员:</span>
        <el-select
          class="select"
          multiple
          v-model="curStaff"
          filterable
          placeholder="请选择"
        >
          <el-option
            popper-class="select"
            v-for="item in staffList"
            :key="item.id"
            :label="item.name"
            :value="item.name"
          ></el-option>
        </el-select>
      </div>
     
      <div style="height: 40px; width: 100%"></div>
      <div class="btnBox">
        <div class="btnItem" @click="close">取消</div>
        <div class="btnItem submit" @click="submit">确定</div>
      </div>
    </el-drawer>
    <!-- 支付弹窗 -->
    <div v-if="dialogSettlementState">
      <!-- returnGoods -->
      <dialogSettlement
        :type="'returnGoods'"
        :orderId="curOrder._id"
        @submit="dialogSettlementSubmit"
      ></dialogSettlement>
    </div>
  </div>
</template>

<script>
import dialogSettlement from "../../../../components/dialog_settlement.vue";
export default {
  components: { dialogSettlement },
  props: {
    orderNo: {
      default: "",
    },
    tabInfo: {
      default: [],
    },
    row: {
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      curOrder: {},
      drawerStatus: false,
      formLabelWidth: "80px",
      deathInfo: {
        deathDate: "", //亡故时间
        deathRemark: "", //亡故说明
        deathImg: [],
      },
      typeId: "",
      remark: "",
      detail: {},
      isDeath: "false", //是否亡故
      curStaff: [], // 销售人员
      staffList: [], //销售人员列表
      isReturnYuE: "false", //状态
      returnYuEInfo: {
        sales_list: [],
      },
      // 支付弹窗
      dialogSettlementState: false,
      // 收款
      returnAccountParam: {
        name: "", //姓名
        bank_name: "", //开户行
        card_no: "",
      },
    };
  },
  computed: {},
  mounted() {
    // console.log("信息", this.tabInfo);
    console.log("信息111", this.row);
    this.getStaffList();
    this.$nextTick(() => {
      this.drawerStatus = true;
    });
  },
  methods: {
    //创建活体退款
    submit() {
      if (this.remark.length < 20) {
        this.$message({
          type: "error",
          message: "退宠备注不少于20字",
        });
        return;
      }
      // if(this.isReturnYuE=='false'){
      //   if (!this.returnAccountParam.name) {
      //     this.$message({
      //       type: "error",
      //       message: "请输入收款人姓名",
      //     });
      //     return;
      //   }
      // }
      if (this.isDeath == "true") {
        if (!this.deathInfo.deathDate) {
          this.$message({
            type: "error",
            message: "请选择亡故日期",
          });
          return;
        }
      }
      if (this.isDeath == "true") {
        if (this.deathInfo.deathImg.length < 1) {
          this.$message({
            type: "error",
            message: "请上传亡故图片",
          });
          return;
        }
      }
      if (this.isDeath == "true") {
        if (this.deathInfo.deathRemark.length < 20) {
          this.$message({
            type: "error",
            message: "亡故说明不少于20字",
          });
          return;
        }
      }

      if (this.isReturnYuE == "false") {
        this.curOrder = this.row;
        let loading = this.$loading();
        let params = {
          orderNo: this.orderNo,
          remark: this.remark,
          isReturnYuE: this.isReturnYuE,
          isDeath: this.isDeath,
          deathInfo: this.deathInfo,
          returnYuEInfo: {},
          returnAccountParam: this.returnAccountParam,
        };
        if (this.deathInfo.deathDate) {
          params.deathInfo.deathDate = this.$public.FTimeStr10(
            this.deathInfo.deathDate.getTime()
          );
        } else {
          params.deathInfo.deathDate = "";
        }
        var arr1 = [];
        this.staffList.forEach((itemA) => {
          this.curStaff.forEach((itemB) => {
            if (itemA.name === itemB) {
              const obj = {
                sales_id: itemA.id,
                sales_name: itemA.name,
              };
              arr1.push(obj);
            }
          });
        });
        params.returnYuEInfo.sales_list = arr1;

        this.$http
          .post("/api/ReturnOrder/Return/CreateReturnPetOrder", params)
          .then((res) => {
            loading.close();
            if (res.code === 0) {
              //   console.log('退钱', res);
              // this.curOrder._id = res.data;
              // this.dialogSettlementState = true;
              this.delInfo();
            }
          });
      } else {
        if (!this.curStaff.length) {
          this.$message({
            type: "error",
            message: "销售人员不为空",
          });
          return;
        }
        let loading = this.$loading();
        let params = {
          orderNo: this.orderNo,
          remark: this.remark,
          isReturnYuE: this.isReturnYuE,
          isDeath: this.isDeath,
          deathInfo: this.deathInfo,
          returnYuEInfo: {},
        };
        var arr = [];
        this.staffList.forEach((itemA) => {
          this.curStaff.forEach((itemB) => {
            if (itemA.name === itemB) {
              const obj = {
                sales_id: itemA.id,
                sales_name: itemA.name,
              };
              arr.push(obj);
            }
          });
        });
        params.returnYuEInfo.sales_list = arr;
        if (this.deathInfo.deathDate) {
          params.deathInfo.deathDate = this.$public.FTimeStr10(
            this.deathInfo.deathDate.getTime()
          );
        } else {
          params.deathInfo.deathDate = "";
        }
        console.log(params);
        this.$http
          .post("/api/ReturnOrder/Return/CreateReturnPetOrder", params)
          .then((res) => {
            loading.close();
            if (res.code === 0) {
              // console.log('退充值', res);
              this.$emit("submit", { type: "close" });
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.delInfo();
            }
          });
      }
    },
    dialogSettlementSubmit(a) {
      this.dialogSettlementState = false;
      if (a == "cancel") {
        console.log(a);
      } else if (a == "fail") {
        this.$message({
          message: "结算失败",
          type: "error",
        });
      } else if (a == "success") {
        this.$message({
          message: "结算成功",
          type: "success",
        });
        this.$emit("submit", { type: "close" });
      }
    },
    //清空输入框
    delInfo() {
      this.remark = "";
      this.deathInfo = {};
      this.return_account_info = {};
      this.$emit("submit", { type: "close" });
    },
    //转移触发轮播图上传按钮
    handleUploadClick() {
      this.$refs.file.click();
    },
    //删除轮播图图片
    handleDeleteBannerImgClick(index) {
      this.deathInfo.deathImg.splice(index, 1);
    },

    //上传轮播图
    changeFile(e) {
      let that = this;
      var index = e.target.files[0].name.lastIndexOf(".");
      var ext = e.target.files[0].name.substr(index + 1);
      var formData = new FormData();
      if (ext === "png" || ext === "jpg" || ext === "jpeg") {
        formData.append("img", e.target.files[0]);
        this.$upload
          .uploadImg_dir(formData, { dir: "businessShopImg" })
          .then((data) => {
            if (data.timestamp) {
              // let obj = {
              //   url: data.url
              // };
              that.deathInfo.deathImg.push(data.url);
            }
          });
      } else {
        this.$message({
          message: "只能上传jpg,png格式的文件",
          type: "error",
        });
      }
    },
    // 获取销售人员列表
    getStaffList() {
      let params = {
        keyword: "", //关键字
        pageIndex: 1,
        pageSize: 100,
      };
      this.$http.get("/api/Staff/List", params).then((res) => {
        if (res.code == 0) {
          res.data.data.forEach((item) => {
            const obj = {
              id: item._id,
              name: item.basic_info.nick_name,
            };
            this.staffList.push(obj);
          });
          const name = this.tabInfo[0].staff.trim();
          this.staffList.forEach((item) => {
            if (item.name === name) {
              this.curStaff.push(item.name);
            }
          });
        }
      });
    },
    close() {
      this.$emit("submit", { type: "close" });
    },
  },
};
</script>

<style scoped lang="scss">
.drawer {
  
  width: 0;
  padding: 0 0 0 0;
  ::v-deep.el-drawer {
    .el-drawer__body {
      overflow: auto;
    }
  }
}
.msgBox {
  display: flex;
  // padding: 20px;
  margin-bottom: 5px;
  & > span {
    // display: inline-block;
    padding: 20px;
    text-align: right;
  }
  .msgBoxL {
    height: 46px;
    line-height: 46px;
  }
}
.btnBox {
  width: 100%;
  font-size: 14px;
  color: #fff;
  line-height: 40px;
  display: flex;
  position: absolute;
  bottom: 0;
  z-index: 10;
  .btnItem {
    text-align: center;
    width: 100%;
    background-color: #d6d6d6;
    cursor: pointer;
    &.submit {
      background-color: $mainColor;
    }
  }
}
.imgItem {
  position: relative;
  margin-right: 15px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 128px;
  height: 128px;
  line-height: 128px;
  text-align: center;
  background: #f0f0f7;
  border: 1px dashed #b0b0bf;
  border-radius: 8px;
  box-sizing: border-box;
}
.avatar {
  width: 128px;
  height: 128px;
  display: block;
  object-fit: cover;
}
.imgItem i {
  position: absolute;
  top: -10px;
  right: -10px;
}
</style>
